import { array, object, string } from "yup";

const nameValidationSchema = string()
  .required("Name is required")
  .max(60, "Name must be less than 60 characters")
  .matches(
    /^[A-Za-z0-9_\- ]*$/,
    "Can only contain letters, numbers, spaces, dashes and underscores.",
  );

const notesValidationSchema = string()
  .notRequired()
  .max(200, "Notes must be less than 200 characters");

const createApiKeyValidationSchema = object({
  name: nameValidationSchema,
  notes: notesValidationSchema,
});

const createAppValidationSchema = createApiKeyValidationSchema.shape({
  name: nameValidationSchema.trim(),
  products: array()
    .of(string().required())
    .min(1, "Select at least one API.")
    .required("Select at least one API."),
});

const updateApiKeyValidationSchema = object({
  displayName: nameValidationSchema,
  notes: notesValidationSchema,
});

const updateAppValidationSchema = updateApiKeyValidationSchema.shape({
  displayName: nameValidationSchema.trim(),
  status: string()
    .oneOf(["approved", "revoked"], "Choose Approved or Revoked.")
    .required("Choose an app status."),
  products: array()
    .of(string().required())
    .min(1, "Select at least one API.")
    .required("Select at least one API."),
});

export {
  createApiKeyValidationSchema,
  createAppValidationSchema,
  updateApiKeyValidationSchema,
  updateAppValidationSchema,
};
